import { InstagramLogo, TiktokLogo, FacebookLogo } from "@phosphor-icons/react";
import Logo from "@/components/site/Logo";
import useSiteSettings from "@/hooks/useSiteSettings";

export default function Footer() {
    const { settings } = useSiteSettings();
    const hours = settings.hours || [];
    return (
        <footer
            data-testid="site-footer"
            className="bg-accent text-accent-foreground py-16"
        >
            <div className="mx-auto w-full max-w-7xl px-4 md:px-8">
                <div className="grid md:grid-cols-4 gap-10">
                    <div className="md:col-span-2">
                        <div className="flex items-center gap-3 mb-4">
                            <Logo size={56} className="rounded-full bg-white p-1 shadow-md" />
                            <span className="font-display font-black text-2xl">J & W Deli</span>
                        </div>
                        <p className="text-white/70 max-w-md leading-relaxed italic">
                            "La esquina del Sabor" — authentic Dominican-American deli on Foxon Blvd. Family recipes, fresh every day.
                        </p>
                        <div className="flex gap-3 mt-6">
                            <Social href="https://instagram.com" icon={<InstagramLogo size={20} weight="bold" />} testid="footer-ig" />
                            <Social href="https://tiktok.com" icon={<TiktokLogo size={20} weight="bold" />} testid="footer-tt" />
                            <Social href="https://facebook.com" icon={<FacebookLogo size={20} weight="bold" />} testid="footer-fb" />
                        </div>
                    </div>
                    <div>
                        <p className="text-xs font-bold uppercase tracking-widest text-secondary mb-4">Visit</p>
                        <p className="text-white/80 leading-relaxed">
                            405 Foxon Blvd<br />
                            New Haven, CT 06513
                        </p>
                        <a
                            href="tel:+12034666226"
                            className="inline-block mt-3 text-white/80 hover:text-secondary"
                            data-testid="footer-phone"
                        >
                            (203) 466-6226
                        </a>
                    </div>
                    <div>
                        <p className="text-xs font-bold uppercase tracking-widest text-secondary mb-4">Hours</p>
                        <ul className="text-white/80 leading-relaxed space-y-1 text-sm">
                            {hours.map((h, i) => (
                                <li key={i}>
                                    <span className="font-semibold">{h.days}</span> · {h.open} – {h.close}
                                </li>
                            ))}
                        </ul>
                    </div>
                </div>
                <div className="mt-12 pt-8 border-t border-white/10 flex flex-col md:flex-row justify-between gap-3 text-xs uppercase tracking-widest text-white/50">
                    <p>© {new Date().getFullYear()} J & W Deli. All rights reserved.</p>
                    <p>Dominican Deli · Latin Food New Haven · SEO 06513</p>
                </div>
            </div>
        </footer>
    );
}

function Social({ href, icon, testid }) {
    return (
        <a
            href={href}
            target="_blank"
            rel="noreferrer"
            data-testid={testid}
            className="grid place-items-center h-10 w-10 rounded-full border border-white/20 hover:bg-secondary hover:text-secondary-foreground hover:border-secondary transition"
        >
            {icon}
        </a>
    );
}
